/* ============================================
   Pour de Vrai — theme.js
   Smooth scroll, GSAP scaffolding, micro-helpers
   ============================================ */

(function () {
  'use strict';

  const ready = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  ready(function () {
    initSmoothScroll();
    initGsapBridge();
    initSkipToContent();
    initRevealOnScroll();
    initAnchorLinks();
    initScenes();
  });

  /* Scènes scroll « pièce d'or » : le site se tient en un bloc et bouge avec
     le scroll (façon Oura). Hero épinglé + zoom + retrait du texte, parallax
     doux sur les médias. Desktop seulement, coupé sous reduced-motion. */
  function initScenes() {
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.matchMedia({
      '(min-width: 768px)': function () {
        const hero = document.querySelector('.hero');
        const stage = document.querySelector('.hero__stage');
        if (hero && stage) {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: hero,
              start: 'top top',
              end: '+=40%',
              scrub: 0.5,
              pin: true,
              pinSpacing: true,
              anticipatePin: 1,
            },
          });
          tl.to(stage, { scale: 1.12, ease: 'none' }, 0)
            .to('.hero__overlay--top', { opacity: 0, y: -40, ease: 'none' }, 0)
            .to('.hero__specs', { opacity: 0, y: -20, ease: 'none' }, 0)
            .to('.hero__scroll', { opacity: 0, ease: 'none' }, 0)
            .to('.hero__cta', { opacity: 0, y: 24, ease: 'none' }, 0);
        }

        // Parallax doux : les médias glissent avec le scroll (continuité du mouvement).
        gsap.utils.toArray('[data-parallax]').forEach(function (el) {
          const depth = parseFloat(el.getAttribute('data-parallax')) || 8;
          gsap.fromTo(
            el,
            { yPercent: depth },
            {
              yPercent: -depth,
              ease: 'none',
              scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true },
            }
          );
        });
      },
    });
  }

  function initAnchorLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const hash = link.getAttribute('href');
      if (!hash || hash === '#' || hash.length < 2) return;
      const target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
        window.__lenis.scrollTo(target, { offset: -20, duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (history.pushState) history.pushState(null, '', hash);
    });
  }

  function initRevealOnScroll() {
    const targets = document.querySelectorAll('[data-reveal], .royaume__media');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    targets.forEach(el => io.observe(el));
  }

  function initSmoothScroll() {
    if (prefersReducedMotion || typeof Lenis === 'undefined') return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    window.__lenis = lenis;
  }

  function initGsapBridge() {
    if (typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      if (window.__lenis) {
        window.__lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add((time) => window.__lenis.raf(time * 1000));
        gsap.ticker.lagSmoothing(0);
      }
    }
    window.__gsapReady = true;
    document.dispatchEvent(new CustomEvent('gsap:ready'));
  }

  function initSkipToContent() {
    const link = document.querySelector('.skip-to-content');
    if (!link) return;
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: false });
      }
    });
  }
})();
